import get from 'lodash/get';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { Sticky } from 'react-sticky';
import { bindActionCreators } from 'redux';

import HelpIcon from '../../../static/icons/header_help.svg';
import HelpIconDark from '../../../static/icons/header_help_dark.svg';
import MenuIcon from '../../../static/icons/ic_menu_24.svg';
import LogoPandoraIcon from '../../../static/icons/logo/ic_logo_pandora_r.svg';
import * as Actions from '../../actions';
import { openHamburgerMenu } from '../../actions/Overlay';
import { enableBodyScrolling } from '../../actions/Scroll';
import Icon from '../../components/Icon/Icon';
import IconInteractive from '../../components/lib/IconInteractive/IconInteractive';
import NavHorizontal from '../../components/lib/NavHorizontal/NavHorizontal';
import determineShouldDropSearchToNextLine from '../../components/SearchResponsiveHelper/SearchResponsiveHelper';
import {
  AriaAttributes,
  AriaRoles,
  messages as AriaValues,
} from '../../constants/AccessibilityConstants';
import { messages as m } from '../../constants/Anon';
import * as Community from '../../constants/Community';
import { StatsOnboardingActions } from '../../constants/Onboarding';
import QA from '../../constants/QATags';
import { getCommunitySSOUrl } from '../../lib/ApplicationUtil';
import { isMobileDevice } from '../../lib/CapabilitiesUtils';
import { getIsResponsiveSubscriptionEnabled } from '../../lib/configuration/TunerVarUtils';
import { isAnonymousListener } from '../../lib/ListenerUtils';
import {
  getHelpUrl,
  getLoginPath,
  getLogoutPath,
  getPlansPath,
  getRegisterPath,
  getRootPath,
  getSubscriptionPath,
  getUpgradeLandingPath,
} from '../../lib/RouteUtils';
import { getIsMainSearchActive } from '../../lib/UIStateUtils';
import { createBEM } from '../../lib/utils/css';
import styles from '../../sass/definitions/_media-queries.scss';
import * as Selectors from '../../selectors';

import './AnonHeader.scss';

// TODO - rename AnonHeader because it's not just for anonymous listeners anymore WEBCLIENT-7050
export class AnonHeader extends React.Component {
  static propTypes = {
    showLogo: PropTypes.bool,
    sticky: PropTypes.bool,
    hasStickyState: PropTypes.bool,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    isOnboardingPage: PropTypes.bool,
    onUpgradeSplash: PropTypes.bool,
    onPlansSplash: PropTypes.bool,
    isAnonymous: PropTypes.bool,
    openHamburgerMenu: PropTypes.func,
    viewPlansOnClick: PropTypes.shape({
      scroll: PropTypes.func,
      ref: PropTypes.node,
      isActive: PropTypes.bool,
      callback: PropTypes.func,
    }),
    router: PropTypes.object,
    isBackgroundDark: PropTypes.bool,
    isSearchActive: PropTypes.bool,
    isMobileDevice: PropTypes.bool,
    enableBodyScrolling: PropTypes.func,
    isLoginPage: PropTypes.bool,
    isSignUpPage: PropTypes.bool,
    isWidthXs: PropTypes.bool,
    linkClicked: PropTypes.func,
    signUpClicked: PropTypes.func,
    viewPlansClicked: PropTypes.func,
    isPartnerUpgradeFlow: PropTypes.bool,
    navigateToCommunity: PropTypes.func,
    communityUrl: PropTypes.string,
    shouldDropSearchToNextLine: PropTypes.bool,
    isResponsiveSubscriptionEnabled: PropTypes.bool,
  };

  static defaultProps = {
    showLogo: true,
    sticky: false,
    onMouseEnter: noop,
    onMouseLeave: noop,
    isBackgroundDark: true,
    isLoginPage: false,
    isSignUpPage: false,
  };

  onHelpClicked = () => {
    this.props.linkClicked(StatsOnboardingActions.HELP_CLICKED);
    window.location = getHelpUrl();
  };

  onHamburgerIconClicked = anonLinks => {
    this.props.linkClicked(StatsOnboardingActions.MENU_CLICK);
    this.props.openHamburgerMenu(anonLinks, this.onHamburgerLinkClicked);
  };

  onHamburgerLinkClicked = url => {
    switch (url) {
      case getRegisterPath():
        this.props.linkClicked(StatsOnboardingActions.MENU_SIGNUP);
        break;
      case getLoginPath():
        this.props.linkClicked(StatsOnboardingActions.MENU_LOGIN);
        break;
      case getHelpUrl():
        this.props.linkClicked(StatsOnboardingActions.MENU_HELP);
        break;
    }
    this.onLinkClicked(url);
  };

  onLinkClicked = (url, logAction) => {
    this.props.linkClicked(logAction);
    switch (url) {
      case getHelpUrl():
        this.onHelpClicked();
        break;
      case this.props.communityUrl:
        this.props.navigateToCommunity(true, {
          action: Community.EventAction.COMMUNITY_CLICKED_FROM_HAMBURGER,
          view_mode: Community.ViewMode.HAMBURGER_MENU,
        });
        break;
      default:
        this.props.router.push(url);
    }
  };

  renderAnonNavLinks = anonLinks => {
    return (
      <div className='AnonHeader__navLinks AnonHeader__navLinks__new'>
        <NavHorizontal
          isBackgroundDark={this.props.isBackgroundDark}
          links={anonLinks}
          isWhiteText={this.props.isBackgroundDark}
          onLinkClicked={this.onLinkClicked}
        />
      </div>
    );
  };

  renderOpenBurgerMenuIcon = anonLinks => {
    return (
      <div className='AnonHeader__burgerIcon'>
        <IconInteractive
          isDark={this.props.isBackgroundDark}
          onClick={() => {
            this.onHamburgerIconClicked(anonLinks);
          }}
          glyph={MenuIcon}
        />
      </div>
    );
  };

  scrollToPlans = () => {
    this.onLinkClicked(getRootPath());
    this.props.enableBodyScrolling();
    this.props.viewPlansOnClick.scroll(
      event,
      this.props.viewPlansOnClick.ref,
      this.props.viewPlansOnClick.callback,
    );
    setTimeout(() => {
      if (get(this, 'props.viewPlansOnClick.ref.current.childNodes[0]')) {
        this.props.viewPlansOnClick.ref.current.childNodes[0].focus();
      }
    }, 1000);
  };

  maybeRenderLogo = () => {
    if (!this.props.showLogo) {
      return null;
    }

    const iconAriaAttributes = {
      [AriaAttributes.HIDDEN]: true,
    };

    const linkAriaAttributes = {
      [AriaAttributes.LABEL]: AriaValues.pandoraLogo.defaultMessage,
    };

    const iconClasses = createBEM('AnonHeader__logo__icon', {
      onboarding: this.props.isOnboardingPage,
      lightTheme: !this.props.isBackgroundDark,
    });

    return (
      <div className='AnonHeader__logo' data-qa={QA.HPI}>
        <Link className='AnonHeader__logo__link' to={getRootPath()} {...linkAriaAttributes}>
          <Icon className={iconClasses} glyph={LogoPandoraIcon} aria={iconAriaAttributes} />
        </Link>
      </div>
    );
  };

  renderHelpLinkOld = () => {
    return (
      <Link className='AnonHeader__help' onClick={this.onHelpClicked}>
        <Icon
          className='icon-help'
          glyph={this.props.isBackgroundDark ? HelpIcon : HelpIconDark}
          qaTag={QA.HHI}
        />
      </Link>
    );
  };

  onViewPlansClick = () => {
    this.scrollToPlans();
    this.props.viewPlansClicked();
  };

  getViewPlanLink = () => {
    if (this.props.isOnboardingPage) {
      return {
        label: <FormattedMessage {...m.viewPlans} />,
        type: 'scrollTo',
        onClick: this.onViewPlansClick,
        isActive: this.props.viewPlansOnClick.isActive,
      };
    }
    return {
      label: <FormattedMessage {...m.viewPlans} />,
      url: this.props.isAnonymous ? getPlansPath() : getUpgradeLandingPath(),
      logAction: StatsOnboardingActions.CLICK_VIEW_PLANS,
      onClick: this.props.viewPlansClicked,
      isActive: this.props.onPlansSplash,
      isHidden: this.props.isPartnerUpgradeFlow,
    };
  };

  getAnonLinks = () => {
    return [
      this.getViewPlanLink(),
      {
        label: <FormattedMessage {...m.signUp} />,
        url: getRegisterPath(),
        logAction: StatsOnboardingActions.CLICK_SIGN_UP_LANDING,
        onClick: this.props.signUpClicked,
        isActive: this.props.isSignUpPage,
        isHidden: !this.props.isAnonymous,
      },
      {
        label: <FormattedMessage {...m.login} />,
        url: getLoginPath(),
        logAction: StatsOnboardingActions.CLICK_LOGIN_LANDING,
        isActive: this.props.isLoginPage,
        isHidden: !this.props.isAnonymous || this.props.isMobileDevice,
      },
      {
        label: <FormattedMessage {...m.help} />,
        url: getHelpUrl(),
        isHidden: !this.props.isWidthXs,
      },
      {
        label: <FormattedMessage {...m.subscription} />,
        url: getSubscriptionPath(),
        isHidden: !this.props.isResponsiveSubscriptionEnabled || !this.props.isMobileDevice,
      },
      {
        label: <FormattedMessage {...m.community} />,
        url: this.props.communityUrl,
        isHidden: !this.props.isWidthXs,
      },
      {
        label: <FormattedMessage {...m.logout} />,
        url: getLogoutPath(),
        isHidden: this.props.isAnonymous,
      },
    ];
  };

  renderButtons = () => {
    const ariaOptions = {
      role: [AriaRoles.NAVIGATION],
      [AriaAttributes.LABEL]: 'utility',
    };

    if (this.props.onUpgradeSplash) {
      return;
    }

    const navLinks = this.getAnonLinks();

    return (
      <div>
        <div className='AnonHeader__anonButtons' {...ariaOptions}>
          {this.renderAnonNavLinks(navLinks)}
          {!this.props.isWidthXs && this.renderHelpLinkOld()}
        </div>
        <div className='AnonHeader__anonBurger' {...ariaOptions}>
          {this.renderOpenBurgerMenuIcon(navLinks)}
        </div>
      </div>
    );
  };

  render() {
    const anonClasses = createBEM('AnonHeader', {
      sticky: this.props.hasStickyState && !this.props.isSearchActive,
      search: this.props.isSearchActive,
      onboardingMobile: this.props.isMobileDevice && this.props.isOnboardingPage,
      shouldDropSearchToNextLine: this.props.shouldDropSearchToNextLine,
    });

    return (
      <div
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        role={AriaRoles.BANNER}
      >
        {this.props.sticky && (
          <Sticky
            className={anonClasses}
            stickyStyle={this.props.isWidthXs ? { width: '100%' } : {}}
          >
            {this.maybeRenderLogo()}
            {this.renderButtons()}
          </Sticky>
        )}
        {!this.props.sticky && (
          <div className={anonClasses}>
            {this.maybeRenderLogo()}
            {this.renderButtons()}
          </div>
        )}
      </div>
    );
  }
}
export function mapStateToProps(state) {
  const isSearchActive = getIsMainSearchActive(state);
  const isWidthXs = window.innerWidth < parseInt(styles.BREAK_WIDTH_XS, 10);
  const isAnonymous = isAnonymousListener(state);
  const isPartnerUpgradeFlow = Selectors.Payments.isPartnerUpgradeFlow(state);
  const isResponsiveSubscriptionEnabled = getIsResponsiveSubscriptionEnabled(state);
  return {
    isAnonymous,
    isMobileDevice: isMobileDevice(state),
    isSearchActive,
    isWidthXs,
    isPartnerUpgradeFlow,
    communityUrl: getCommunitySSOUrl(),
    isResponsiveSubscriptionEnabled,
  };
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      openHamburgerMenu,
      enableBodyScrolling,
      linkClicked: Actions.UseCases.linkClicked,
      navigateToCommunity: Actions.UseCases.navigateToCommunity,
      signUpClicked: Actions.Integrations.signUpClicked,
      viewPlansClicked: Actions.Integrations.viewPlansClicked,
    },
    dispatch,
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(determineShouldDropSearchToNextLine(AnonHeader)),
);
